import { BrowserRouter as Router, useRoutes } from "react-router-dom";
import { routes } from "./routes";
import ErrorBoundary from "@components/common/ErrorBoundary/ErrorBoundary";
import "./App.css";
import { QueryProvider } from "@providers/QueryProvider";
import { ReduxProvider } from "@providers/ReduxProvider";
import { SnackbarProvider } from "@providers/SnackbarProvider";
import { MUIThemeProvider } from "@providers/MUIThemeProvider";
import NotificationStreamProvider from "@features/Notification/NotificationStreamProvider";
import { PortalSourceWpProvider } from "@providers/PortalSourceWpProvider";
// AppRoutes component to use useRoutes hook
const AppRoutes = () => {
	const element = useRoutes(routes);
	return element;
};

// AppRouter component to wrap AppRoutes with Router
const AppRouter = () => {
	return (
		<Router>
			<PortalSourceWpProvider>
				<AppRoutes />
			</PortalSourceWpProvider>
		</Router>
	);
};

function App() {
	return (
		<ErrorBoundary>
			<MUIThemeProvider>
				<ReduxProvider>
					<QueryProvider>
						<SnackbarProvider>
							<NotificationStreamProvider>
								<AppRouter />
							</NotificationStreamProvider>
						</SnackbarProvider>
					</QueryProvider>
				</ReduxProvider>
			</MUIThemeProvider>
		</ErrorBoundary>
	);
}

export default App;
